var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$store.state.admin.user)?_c('Admin',{staticClass:"text-xs"}):_c('LoaderFullscreen')}
var staticRenderFns = []

export { render, staticRenderFns }